import React from "react";
import DialogBox from "@/components/Common/DialogBox";

const formatSentAt = (value) => {
  if (!value) return "-";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return `${date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  })} ${date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
};

const MarketingHistoryDetailsModal = ({
  isOpen,
  onClose,
  row,
  channelLabels = {},
}) => {
  const isSms = row?.channel === "sms";
  const body = isSms
    ? row?.sms_body || row?.email_body
    : row?.email_body || row?.sms_body;

  return (
    <DialogBox
      isOpen={isOpen}
      onClose={onClose}
     
      className="w-[45%] max-md:w-[90%]"
      showIcon={false}
      contentClassName="overflow-visible"
    >
      <div className="space-y-5">
        <div className="border-b border-border pb-4">
       
          <p className="text-lg font-semibold text-primary-dark break-words leading-7">
            {row?.name || "-"}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Channel</p>
            <p className="text-sm text-foreground">
              {channelLabels[row?.channel] || row?.channel || "-"}
            </p>
          </div>
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Sent At</p>
            <p className="text-sm text-foreground">
              {formatSentAt(row?.sent_at)}
            </p>
          </div>
        </div>

        <div>
          <p className="text-sm font-medium text-foreground mb-2">Body</p>
          <div className="rounded-lg border border-border bg-gray-50 px-4 py-4">
            {body ? (
              isSms ? (
                <p className="max-h-[35vh] overflow-y-auto text-xs text-foreground">
                  {body}
                </p>
              ) : (
                <div
                  className="max-h-[35vh] overflow-y-auto pr-1 prose prose-sm max-w-none"
                  dangerouslySetInnerHTML={{ __html: body }}
                />
              )
            ) : (
              <p className="text-sm text-muted-foreground">-</p>
            )}
          </div>
        </div>
      </div>
    </DialogBox>
  );
};

export default MarketingHistoryDetailsModal;
